var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndustria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#0DA9D5",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 25V9H16.8V12.6667H25V25H9ZM10.2 23.6667H15.6V21.3333H10.2V23.6667ZM10.2 20H15.6V17.6667H10.2V20ZM10.2 16.3333H15.6V14H10.2V16.3333ZM10.2 12.6667H15.6V10.3333H10.2V12.6667ZM16.8 23.6667H23.8V14H16.8V23.6667ZM18.4 17.6667V16.3333H21.7V17.6667H18.4ZM18.4 21.3333V20H21.7V21.3333H18.4Z",
    fill: "#0DA9D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndustria);
export default __webpack_public_path__ + "static/media/icon-industria.ad2e250f.svg";
export { ForwardRef as ReactComponent };